module.exports = __webpack_public_path__ + "static/media/plurall.3541643c.png";